import { combineReducers } from "redux";

const initialState = {};
const editRejectedInitialState = {
  editReject: []
};
// const initialState = {
//   editReject: []
// };

function correctionReducer(state = initialState, action) {
  // Handle different actions and update the state accordingly
  if (action.type === "EDIT") {
    return { ...state, corrections: action.payload };
  }

  // Add more cases for your specific actions
  else {
    return state;
  }
}



function EditToolReducer(state = initialState, action) {

  if (action.type === "EDITTOOL") {
    console.log("data coming to the EditToolReducer function type EDITTOOL is :", action.payload)
    //clean the editcorrections into new to set new corrections
    if (!action.payload.data) {

      return {
        ...state,
        EditCorrections: {}
      }
    }
    //need to pass the key and data what are the things we are going to update
    return {
      ...state,
      EditCorrections: {
        ...state.EditCorrections,
        [action.payload.key]: action.payload.data

      }
    };
  }

  else if (action.type === "TOOLUPDATE") {

    const { [action.payload.key]: _, ...rest } = state.EditCorrections;
    return {
      ...state,
      EditCorrections: rest
    };
  }
  else {
    return state;
  }
}


function queriesReducer(state = initialState, action) {
  if (action.type === "QueryEdit") {
    return { ...state, queries: action.payload };
  } else {
    return state;
  }
}

function UploadTexFile(state = initialState, action) {
  if (action.type === "UploadTex") {
    return { ...state, tex: action.payload };
  } else {
    return state;
  }
}


const autoSuggestionInitialState = {
  suggestions: []
};

function autoSuggestion(state = autoSuggestionInitialState, action) {
  console.log("autoSuggestion reducer - action:", action.type, action.payload);

  if (action.type === "addAutoSuggestion") {
    return {
      ...state,
      suggestions: action.payload
    };
  } else if (action.type === "removeAutoSuggestion") {
    // Remove a single suggestion by matching anchor positions
    const itemToRemove = action.payload;
    console.log("Removing item:", itemToRemove);

    return {
      ...state,
      suggestions: state.suggestions.filter(
        item => {
          // Check if this is the item to remove
          const isSameRow = item.startAnchor?.row === itemToRemove.startAnchor?.row;
          const isSameCol = item.startAnchor?.column === itemToRemove.startAnchor?.column;

          // Keep items that DON'T match (filter out the one we want to remove)
          return !(isSameRow && isSameCol);
        }
      )
    };
  } else if (action.type === "clearAutoSuggestion") {
    return {
      ...state,
      suggestions: []
    };
  } else {
    return state;
  }
}

function EditRejected(state = {
  editReject: [],
  autoSuggestionReject: [] // Separate rejection list for auto suggestions
}, action) {
  if (action.type === "AddReject") {
    console.log("data coming to the AddReject is:", action.payload);
    return {
      ...state,
      editReject: [...state.editReject, ...action.payload],
    };
  } else if (action.type === "AddAutoSuggestionReject") {
    // Handle auto suggestion rejections
    return {
      ...state,
      autoSuggestionReject: [...state.autoSuggestionReject, action.payload]
    };
  } else if (action.type === "EmptyReject") {
    return {
      ...state,
      editReject: []
    };
  } else if (action.type === "EmptyAutoSuggestionReject") {
    return {
      ...state,
      autoSuggestionReject: []
    };
  } else {
    return state;
  }
}





function latexSearchText(state = initialState, action) {
  if (action.type === "latexSearch") {
    return { ...state, latexSearch: action.payload };
  } else {
    return state;
  }
}

function pdfSearchText(state = initialState, action) {

  if (action.type === "pdfSearch") {
    return { ...state, pdfSearch: action.payload };
  } else {
    return state;
  }
}

function toolsSelection(state = initialState, action) {
  if (action.type === "toolSearch") {
    return { ...state, toolSearch: action.payload };
  } else {
    return state;
  }
}

function setClientWidth(state = initialState, action) {
  if (action.type === "clientwidth") {
    return { ...state, clientwidth: action.payload };
  } else {
    return state;
  }
}

function setDragging(state = initialState, action) {
  if (action.type === "dragging") {
    return { ...state, dragging: action.payload };
  } else {
    return state;
  }
}

function selectEplStyles(state = initialState, action) {
  if (action.type === "Submit") {

    return { ...state, function: action.payload };
  } else {
    return state;
  }
}

function selectEditStyles(state = initialState, action) {
  console.log("state in the selected Editstyles", state)
  if (action.type === "ToolSubmit") {

    if (!action.payload.key) {

      return {
        ...state,
        function: {},
        isChecked: action.payload.isChecked
      }
    }

    return {
      ...state, function: {
        [action.payload.key]: action.payload.data
      }, isChecked: action.payload.isChecked
    };
    //setting like key:value -> epl:['Removecommands'] and is checked true 

  }
  else if (action.type === "ToolRejected") {
    const existingData = state.function[action.payload.key] || [];


    const filteredData = existingData.filter(
      (item) => action.payload.data !== item)

    return {
      ...state,
      function: {
        ...state.function,
        [action.payload.key]: filteredData,
      },
    };
  } else {
    return state;
  }
}
//MARK:Toggle project
const projectModeInitialState = {
  projectMode: false
};
function toggleProjectMode(state = projectModeInitialState, action) {
  if (action.type === "projectMode") {
    return { ...state, projectMode: action.payload };
  } else {
    return state;
  }
}
function compileTex(state = initialState, action) {
  if (action.type === "compile") {
    return { ...state, compile: action.payload };
  } else {
    return state;
  }
}
function trackCompile(state = initialState, action) {
  if (action.type === "trackcompile") {
    return { ...state, trackcompile: action.payload };
  } else {
    return state;
  }
}
//state for Trigger shortcut
const compileTexIntial = {
  compileTrigger: false
};
function compileTrigger(state = compileTexIntial, action) {
  switch (action.type) {
    case "TRIGGER_COMPILE":
      return { ...state, compileTrigger: true };
    case "RESET_COMPILE":
      return { ...state, compileTrigger: false };
    default:
      return state;
  }
}

const compileTrackInitial = {
  compileTrackTrigger: false
};
function compileTrackTrigger(state = compileTrackInitial, action) {
  switch (action.type) {
    case "TRIGGER_TRACK_COMPILE":
      return { ...state, compileTrackTrigger: true };
    case "RESET_TRACK_COMPILE":
      return { ...state, compileTrackTrigger: false };
    default:
      return state;
  }
}

function LoadSuggestions(state = initialState, action) {
  if (action.type === "TriggerSuggestions") {
    return { ...state, SuggestionTrigger: action.payload }
  } else {
    return state;
  }
}



// function EditRejected(state = editRejectedInitialState, action) {
//   //in the suggestion edit we can add rejections
//   if (action.type === "AddReject") {
//     console.log("data coming to the ADDReject is :", action.payload, action.payload.key)
//     return {
//       ...state,
//       editReject: [...state.editReject, ...action.payload],
//     };
//   } else if (action.type === "EmptyReject") {
//     return { ...state, editReject: [] };
//   }
//   else {
//     return state;
//   }
// }

function clientSelect(state = initialState, action) {
  if (action.type === "clientselect") {

    return { ...state, clientselect: action.payload }
  } else {
    return state;
  }
}

function updateCorrections(state = initialState, action) {
  if (action.type === "accept") {
    return { ...state, corrections: action };
  } else if (action.type === "reject") {
    return { ...state, corrections: action };
  } else {
    return state;
  }
}

function updateToolCorrections(state = initialState, action) {
  if (action.type === "ToolAccept") {
    console.log("the action in accepting is :", action);
    console.log("accepting style is :", action)
    return { ...state, corrections: action };
  } else if (action.type === "ToolReject") {
    console.log("the action in rejecting is :", action);

    return { ...state, corrections: action };
  } else {
    return state;
  }
}

function EnvironmentTrigger(state = { envTrigger: false }, action) {
  switch (action.type) {
    case "Triggered":
      return { ...state, envTrigger: !state.envTrigger };
    default:
      return state;
  }
}
// function enableOnChange(state = initialState, action) {
//   if(action.type === "onChange"){
//     console.log("reached reducer");
//     console.log(action.payload);
//     return {...state, currentstate: action.payload }
//   }else{
//     return state;
//   }
// }
const rootReducer = combineReducers({
  correction: correctionReducer, // reducer for correction update's
  EditTool: EditToolReducer,
  queries: queriesReducer, // reducer for query update's
  uploadTex: UploadTexFile, // reducer for texfile for compilation
  latexsearch: latexSearchText, // reducer for searching text in editor
  pdfsearch: pdfSearchText, // reducer for searching text in PDF
  toolsearch: toolsSelection, // reducer for searching the tools output in editor.
  clientwidth: setClientWidth,
  dragging: setDragging,
  eplStyles: selectEplStyles,
  editToolRejected: EditRejected,
  toolStyles: selectEditStyles,
  // submitAction: enableOnChange,
  projectMode: toggleProjectMode,
  compileTex: compileTex,
  trackCompile: trackCompile,
  LoadSuggestions: LoadSuggestions,
  compileTrig: compileTrigger,
  compileTrackTrig: compileTrackTrigger,

  updateCorrections: updateCorrections,
  updateToolCorrections: updateToolCorrections,
  clientSelect: clientSelect,
  EnvironmentTrigger: EnvironmentTrigger,
  autoSuggestion: autoSuggestion
});

export default rootReducer;
